import { LANG } from '../../constants/i18n';

export default {
    messages: {
        [LANG.SC]: {
            '展开': '展开',
            '收起': '收起'
        },
        [LANG.TC]: {
            "展开": "展開",
            '收起': '收起'
        },
        [LANG.EN]: {
            "展开": "Unfold",
            '收起': 'Fold'
        },
        [LANG.JA]: {
            "展开": "もっと見る",
            '收起': '折りたたむ'
        }
    }
};